function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject, _templateObject2, _templateObject3;
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import "../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/reactive-element.js";
import { html as o, nothing as g } from "../../../node_modules/.pnpm/lit-html@3.3.1/node_modules/lit-html/lit-html.js";
import "../../../node_modules/.pnpm/lit-element@4.2.1/node_modules/lit-element/lit-element.js";
import { customElement as c } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/decorators/custom-element.js";
import m from "../../../packages/web-components/src/components/fab/gator/fab.gator.scss.js";
import u from "../../../packages/web-components/src/tokens/primitive.tokens.scss.js";
import b from "../../../packages/web-components/src/tokens/semantic.tokens.scss.js";
import { NjcFab as d } from "../fab.js";
import "../../loading-spinner/gator/loading-spinner.gator.js";
import { unsafeCSS as l } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/css-tag.js";
var f = Object.getOwnPropertyDescriptor,
  p = function p(e, s, r, t) {
    for (var a = t > 1 ? void 0 : t ? f(s, r) : s, n = e.length - 1, h; n >= 0; n--) (h = e[n]) && (a = h(a) || a);
    return a;
  };
var i = /*#__PURE__*/function (_d) {
  function i() {
    _classCallCheck(this, i);
    return _callSuper(this, i, arguments);
  }
  _inherits(i, _d);
  return _createClass(i, [{
    key: "render",
    value: function render() {
      return o(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            <button\n                aria-label=", "\n                class=\"gator-fab ", " ", "\"\n                .disabled=\"", "\"\n                aria-disabled=\"", "\"\n                @click=\"", "\"\n            >\n                ", "\n            </button>\n        "])), this.buttonAriaLabel, this.sizeClass, this.loadingClass, this.disabled, this.disabled || this.loading, this.handleClick, this.loading ? this.loadingMarkup : o(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<slot @slotchange=\"", "\"></slot>"])), this.handleSlotChange));
    }
  }, {
    key: "updated",
    value: function updated() {
      this.setIconSizes();
    }
  }, {
    key: "handleSlotChange",
    value: function handleSlotChange(e) {
      var r = e.target.assignedElements();
      var _iterator = _createForOfIteratorHelper(r),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var t = _step.value;
          t.tagName.toLowerCase() === "ngc-icon" && (this._iconElement = t, this.setIconSizes());
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      e.preventDefault(), e.stopPropagation(), !(this.disabled || this.loading) && this.dispatchEvent(new CustomEvent("click", {
        bubbles: !0,
        composed: !0
      }));
    }
  }, {
    key: "setIconSizes",
    value: function setIconSizes() {
      this._iconElement && (this._iconElement.height = this.heightAndWidthForSize, this._iconElement.width = this.heightAndWidthForSize);
    }
  }, {
    key: "buttonAriaLabel",
    get: function get() {
      return this.loading ? this.loadingAriaLabel : this.dataset.ariaLabel ? this.dataset.ariaLabel : this.ariaLabel ? this.ariaLabel : g;
    }
  }, {
    key: "loadingClass",
    get: function get() {
      return this.loading ? "gator-fab_loading" : null;
    }
  }, {
    key: "heightAndWidthForSize",
    get: function get() {
      switch (this.size) {
        case "medium":
          return "24";
        case "large":
          return "36";
        case "xlarge":
          return "40";
        case "small":
        default:
          return "18";
      }
    }
  }, {
    key: "sizeClass",
    get: function get() {
      switch (this.size) {
        case "medium":
          return "gator-fab_medium";
        case "large":
          return "gator-fab_large";
        case "xlarge":
          return "gator-fab_xlarge";
        case "small":
        default:
          return "gator-fab_small";
      }
    }
  }, {
    key: "loadingMarkup",
    get: function get() {
      var e;
      switch (this.size) {
        case "small":
        case "medium":
          e = "medium";
          break;
        case "large":
          e = "large";
          break;
        case "xlarge":
          e = "xlarge";
          break;
        default:
          e = "small";
          break;
      }
      return o(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            <div\n                class=\"gator-fab-loader\"\n                style=\"width: ", "px; height: ", "px\"\n            >\n                <ngc-loading-spinner .size=\"", "\"></ngc-loading-spinner>\n            </div>\n        "])), this.heightAndWidthForSize, this.heightAndWidthForSize, e);
    }
  }]);
}(d);
i.styles = [l(m), l(u), l(b)];
i.shadowRootOptions = _objectSpread(_objectSpread({}, d.shadowRootOptions), {}, {
  delegatesFocus: !0
});
i = p([c("ngc-fab")], i);
export { i as NgcFab };